import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import SEO from "./components/SEO";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Products from "./pages/Products";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Code7sPrivacyPolicy from "./pages/Code7sPrivacyPolicy";
import SudokuPrivacyPolicy from "./pages/SudokuPrivacyPolicy";
import Footer from "./components/Footer";

// Service Pages
import MobileAppPage from "./pages/services/MobileAppPage";
import WebDevelopmentPage from "./pages/services/WebDevelopmentPage";
import ProductDesignPage from "./pages/services/ProductDesignPage";

// Product Pages
import GridLockPage from "./pages/products/GridLockPage";
import StudioToolsPage from "./pages/products/StudioToolsPage";
import NovaPage from "./pages/products/NovaPage";
import SpendNotePage from "./pages/products/SpendNotePage";
import ScoraPage from "./pages/products/ScoraPage";

// portfolio routes
import LandingPageCaseStudy from "./pages/portfolio/LandingPageCaseStudy";
import ShreePage from "./pages/portfolio/ShreePage";
import EmpirePage from "./pages/portfolio/ EmpirePage";

function AppShell() {
  return (
    <>
      <SEO />
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy-policy/code7s" element={<Code7sPrivacyPolicy />} />
        <Route path="/privacy-policy/sudoku" element={<SudokuPrivacyPolicy />} />

        {/* service routes */}
        <Route path="/services/mobile" element={<MobileAppPage />} />
        <Route path="/services/web" element={<WebDevelopmentPage />} />
        <Route path="/services/uiux" element={<ProductDesignPage />} />

        {/* product routes */}
        <Route path="/products/gridlock" element={<GridLockPage />} />
        <Route path="/products/tools" element={<StudioToolsPage />} />
        <Route path="/products/nova" element={<NovaPage />} />
        <Route path="/products/spendnote" element={<SpendNotePage />} />
        <Route path="/products/scora" element={<ScoraPage />} />


        {/* portfolio routes */}
        <Route path="/portfolio/landing-page" element={<LandingPageCaseStudy />} />
        <Route path="/portfolio/shree" element={<ShreePage/>} />
       <Route path="/portfolio/empire" element={<EmpirePage/>} />

      </Routes>

      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}
